<template>
  <div class="header">
    <div v-if="selectedStore && storeConfig" class="headerWrapper">
      <div class="chainInfo">
        <h1 class="chainName" v-if="!branding?.display_options?.hide_chain_name">
          {{ storeConfig.chain_display_name }}
        </h1>
        <p class="storeName">{{ selectedStore.name }}</p>
        <div class="storeInfoWrapper">
          <p v-if="selectedStore?.subtitle">{{ selectedStore.subtitle }}</p>
          <p v-if="!branding?.display_options?.hide_store_address">
            {{ selectedStore.address1 }}, {{ selectedStore.city }}, {{ selectedStore.state }}
            {{ selectedStore.postal_code }}
          </p>
          <p v-if="!branding.display_options?.hide_restaurant_phone_number">
            {{ formatPhoneNumber(selectedStore.phone) }}
          </p>
          <p>{{ getOpenHours }}</p>
        </div>
      </div>
      <div class="linksWrapper">
        <div class="links">
          <a v-for="link in branding?.links" :key="link" class="link" :href="link.url" target="_blank">
            <p>{{ link.name }}</p>
          </a>
          <a v-for="link in selectedStore?.extra?.links" :key="link" class="link" :href="link.url" target="_blank">
            <p>{{ link.name }}</p>
          </a>
        </div>
      </div>
      <img class="storeImage" :src="getHeroImage" alt="hero" loading="lazy" />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import formattingMixins from '@/mixins/formattingMixins'

import storesApi from '@/api/storesApi'
import moment from 'moment'

export default {
  mixins: [formattingMixins],
  computed: {
    ...mapState(['selectedStore', 'branding', 'storeConfig', 'cookies']),
    getMenuLogo() {
      return this.branding.menu_logo_url
    },
    getHeroImage() {
      if (this.selectedStore?.extra?.location_hero_image) {
        return this.selectedStore?.extra?.location_hero_image
      }
      if (this.branding.display_options?.display_store_images_as_hero && this.selectedStore?.extra?.store_image) {
        return this.selectedStore?.extra?.store_image
      }
      return this.branding.hero_image_url
    },
    getOpenHours() {
      let dayNameOfToday = moment(this.selectedStore.today, 'MM/DD/YYYY').format('dddd')
      let todaysHours = this.selectedStore.hours.filter((day) => day.display_name === dayNameOfToday)

      if (todaysHours.length === 0) return 'Closed for today'

      if (todaysHours.length === 1) {
        let hours = todaysHours[0]
        if (!hours.start_time || !hours.end_time) return 'Closed for today'
        if (hours.start_time === '00:00' && hours.end_time === '23:59') return 'Open 24 Hours'
        return (
          'Open from ' +
          moment(hours.start_time, 'HH:mm').format('h:mm A') +
          ' to ' +
          moment(hours.end_time, 'HH:mm').format('h:mm A')
        )
      } else {
        let firstHours = todaysHours[0]
        let lastHours = todaysHours[todaysHours.length - 1]
        if (!firstHours.start_time || !lastHours.end_time) return 'Closed for today'
        return (
          'Open from ' +
          moment(firstHours.start_time, 'HH:mm').format('h:mm A') +
          ' to ' +
          moment(lastHours.end_time, 'HH:mm').format('h:mm A')
        )
      }
    },
  },
  methods: {
    ...mapMutations(['SET_SELECTED_STORE', 'SET_COOKIES']),
    getSelectedStore() {
      let storeId = this.$route.params.storeId
      storesApi
        .getStore(storeId)
        .then((response) => {
          this.SET_SELECTED_STORE(response.data.data)
          this.SET_COOKIES(response.data.cookies)
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
  created() {
    if (!this.selectedStore) {
      this.getSelectedStore()
    }
  },
}
</script>

<style src="../../../assets/css/Main/Layout/HeroView.css" scoped></style>
